import { useState } from "react";
import { EyeFilled, EyeInvisibleFilled } from "@ant-design/icons";
import { matchPassword } from "../utils/validations";

const PasswordCnf = ({
  placeholder,
  value,
  cfmPass,
  onChange,
  require,
  onKeyDown,
}) => {
  const [showPass, setShowPass] = useState("password");

  const pass = () => {
    if (showPass === "password") {
      setShowPass("text");
    } else {
      setShowPass("password");
    }
  };

  const showError = (errorMessage) => {
    return <p style={{ color: "red", fontSize: 15 }}>{errorMessage}</p>;
  };

  const validateInput = () => {
    if (require) {
      if (!value) {
        return showError("Please enter password");
      } else if (!matchPassword(value, cfmPass)) {
        return showError("Password didn't match");
      }
    }
    if (value) {
      if (!matchPassword(value, cfmPass)) {
        return showError("Password didn't match");
      }
    }
    return null;
  };

  return (
    <div className="input_box">
      <figure className="sms">
        <img src="/images/lock.svg" alt="customer"></img>
      </figure>
      <input
        type={showPass}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
      <figure className="eye" onClick={pass}>
        {showPass === "password" && (
          <EyeInvisibleFilled
            style={{
              fontSize: "22px",
              color: "#9aa4b2",
            }}
          />
        )}
        {showPass === "text" && (
          <EyeFilled
            style={{
              fontSize: "22px",
              color: "#9aa4b2",
            }}
          />
        )}
      </figure>
      {validateInput()}
    </div>
  );
};
export default PasswordCnf;
